module.exports = __webpack_public_path__ + "static/media/kingshospital.6e5a45b0.png";